import { useAppContext } from "app/AppContext";
import DebugObjComp from "components/DebugObjComp";
import FForm, { useFormApi } from "components/form";
import FormContent from "components/form/FormContent";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import TextInput from "components/form/input/TextInput";
import PerfilAutorizado from "components/PerfilAutorizado";
import TabContainer from "components/tabs/TabContainer";
import TabPanel from "components/tabs/TabPanel";
import { useEntity } from "entity";
import Cliente from "entity/Cliente";
import useNotification from "notification";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useIsAdmin, usePerfil } from "useAuth";
import ClienteParamEditor from "./ClienteParamEditor";
import Anexo from "components/AnexosComp/components/Anexo";
import { Typography } from "@mui/material";

export default function ClienteForm() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const { showSuccess, showError } = useNotification();

    const { useSetTitle, setActionsView } = useAppContext();
    const form = useFormApi();
    // console.log('form', form)
    // console.log('form.getValues()', form.getValues())
    // const { anexos } = form.getValues()
    const { entity } = useEntity(Cliente, searchParams.get("uid"));
    const isAdmin = useIsAdmin();
    const perfilLogado = usePerfil()
    const newActionAuth = ['r9jrEQXznNgjrZTGCfch'/*, 'RECT03jkyTQW9B2OMz47'*/] //admin ou tecnico
    let perfil = usePerfil()

    useEffect(() => {
        const actions = []
        if (newActionAuth.includes(perfil?.grupoPermissao?.uid)) {
            actions.push({
                uid: "novoForm",
                text: "Novo",
                iconName: "Add",
                sequence: "10",
                action: () => {
                    navigate("/_cliente");
                },
            })
        }
        actions.push({
            uid: "salvarForm",
            text: "Salvar",
            iconName: "Check",
            sequence: "20",
            action: () => {
                form.submit();
            },
        })
        actions.push({
            uid: "sairForm",
            text: "Sair",
            iconName: "Close",
            sequence: "999999",
            action: () => {
                // TODO: exibir diálogo de confirmação se o form estiver dirty.
                navigate("/consulta-clientes");
            },
        })

        setActionsView(actions);

        return () => {
            setActionsView([]);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form, navigate, setActionsView, perfil?.grupoPermissao?.uid]);

    useSetTitle("Cliente");

    function autorizarPerfilAtual(values) {
        if (perfilLogado?.grupoPermissao.nome === "Técnico") {

            if (!values.perfisAutorizado) {
                values.perfisAutorizado = {}
            }

            values.perfisAutorizado[perfilLogado.uid] = true


            // let p = Object.keys(values.perfisAutorizado || [])

            // let foundKey = p.find(perfilKey => perfilKey === perfilLogado.uid)
            // if (foundKey) { // perfil não é mais autorizado
            //     if (!_.get(values.perfisAutorizado, foundKey)) {
            //         _.set(values.perfisAutorizado, perfilLogado.uid, true)
            //     }
            // } else { // perfil nunca foi autorizado
            //     if (values.perfisAutorizado) { // lista de perfis autorizados existe
            //         values.perfisAutorizado[perfilLogado.uid.toString()] = true
            //     } else { // lista não existe
            //         values.perfisAutorizado = []
            //         values.perfisAutorizado[perfilLogado.uid.toString()] = true
            //     }

            // }

        }
    }

    async function handleSubmit(values) {

        autorizarPerfilAtual(values)

        entity.update(values);
        try {
            const success = await entity.save();

            if (success) {
                showSuccess("Cliente salvo com sucesso.");

                searchParams.set("uid", entity.data.uid);
                setSearchParams(searchParams);
            }
        } catch (error) {
            let str = JSON.stringify(error);
            console.log('str ERROR', str)
            console.log('error', error)
            if (error.code === "invalid-argument") {
                str = "Erro de formado de dados. Verifique os parametros do cliente"
            }
            console.log('str ERROR final', str)
            showError(str)
        }
    }

    return (
        <FForm formApi={form} onSubmit={handleSubmit} initialValues={entity.data} sx={{ mt: 1 }}>
            <TabContainer
                TabIndicatorProps={{ sx: { display: 'none' } }}
                sx={{
                    '& .MuiTabs-flexContainer': {
                        flexWrap: 'wrap',
                    },
                }}
            >
                <TabPanel label="Dados" sx={{ m: 2 }}>
                    <FormContent>
                        <FormRow>
                            <TextInput sx={{ flex: 0.5 }} name="sequencialIndex" label="Código" disabled />
                            <SelectInput
                                sx={{ flex: 0.5 }}
                                name="status"
                                label="Status"
                                options={["ATIVO", "INATIVO", "DELETAR"]}
                            />
                            <TextInput sx={{ flex: 2 }} name="nome" label="Nome" />
                            <TextInput name="telefone" label="Telefone" />
                        </FormRow>

                        <FormRow>
                            <TextInput sx={{ flex: 2 }} name="endereco" label="Endereço" />
                            <TextInput name="cidade" label="Cidade" />
                            <TextInput name="estado" label="Estado" />
                        </FormRow>
                    </FormContent>
                </TabPanel>

                <TabPanel label="Parâmetros">
                {/* // TODO: (b_2089) 1º chamando aba de parametros*/}
                {/* Arranquio de Soqueira */}
                    <ClienteParamEditor cliente={entity} form={form} />
                    {/* {console.log('form', form.getValues())} */}
                </TabPanel>

                {isAdmin && <TabPanel label="Usuários">
                    <PerfilAutorizado name="perfisAutorizado" label="Perfis Autorizados" />
                </TabPanel>
                }
                <TabPanel label="Anexos" sx={{ m: 2 }}>
                    <Typography variant={'h6'}>Métodologia de Avaliação</Typography>
                    <Anexo folder={"metodologiasAvaliacao"} />
                </TabPanel>

            </TabContainer>
            <DebugObjComp entity={entity} />
        </FForm>
    );
}
